import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { api, ApiException } from '../api/client';
export default function Login({ onSignedIn }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    async function submit(e) {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            const { user } = await api.login(email, password);
            onSignedIn(user);
        }
        catch (err) {
            if (err instanceof ApiException)
                setError(err.message);
            else
                setError('Network error');
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx("div", { className: "shell", children: _jsxs("form", { className: "card", onSubmit: submit, children: [_jsx("h1", { children: "Sign in" }), _jsx("label", { htmlFor: "email", children: "Email" }), _jsx("input", { id: "email", type: "email", autoComplete: "username", value: email, onChange: (e) => setEmail(e.target.value), required: true, autoFocus: true }), _jsx("label", { htmlFor: "password", children: "Password" }), _jsx("input", { id: "password", type: "password", autoComplete: "current-password", value: password, onChange: (e) => setPassword(e.target.value), required: true }), _jsxs("div", { className: "actions", children: [_jsx("button", { type: "submit", disabled: busy, children: busy ? 'Signing in…' : 'Sign in' }), _jsx("span", { className: "tag", children: "site-starter v2" })] }), error && _jsx("div", { className: "err", children: error })] }) }));
}
